import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
	Button,
	Card,
	FlexGap,
	GraphQLErrorMessage,
	Paragraph,
	StarsIcon,
	Subheading,
	UnderlineLink,
	tokens,
} from '@treams/treams-ui';

import { useAIAssistanceApproval } from '../useAIAssistanceApproval';

const Disclaimer = styled(Paragraph)`
	font-style: italic;
`;

export function AgentChatAIApprovalCard() {
	const { t } = useTranslation();

	const { needsApproval, requiredConditions, approve, approving, error } =
		useAIAssistanceApproval();

	if (!needsApproval || !requiredConditions) {
		return null;
	}

	return (
		<Card width="100%" maxWidth={420}>
			<GraphQLErrorMessage error={error} />
			<FlexGap flexDirection="column" gap={tokens.gap.list} alignItems="center">
				<StarsIcon size={32} color={tokens.brand.icon} />
				<Subheading>{t('aiAgent.approval.title')}</Subheading>
				<Paragraph textAlign="center">{t('aiAgent.approval.description')}</Paragraph>
				<Button
					title={t('aiAgent.approval.button')}
					onClick={() => approve()}
					type="primary"
					loading={approving}
				/>
				<Disclaimer textAlign="center" mt={2}>
					<Trans
						i18nKey="aiAgent.approval.disclaimer"
						components={{
							a: (
								<UnderlineLink
									href={requiredConditions.linkToConditions}
									target="_blank"
									rel="noreferrer"
								/>
							),
						}}
					/>
				</Disclaimer>
			</FlexGap>
		</Card>
	);
}
